<template>
  <div>
    <CCard>
      <CCardBody>
        <CCardTitle>List Role</CCardTitle>
        <div v-if="items">
          <TheTable :items="items" :fields="fields" @roleClicked="getRole($event)"></TheTable>
        </div>
        <div v-else>
          <h2>No item</h2>
        </div>
        x
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import TheTable from "./../containers/TheTable";

export default {
  name: "ListRole",
  data() {
    return {
      fields: [
        {
          key: "name",
          label: "Role name"
        },
        {
          key: "description",
          label: "Description"
        },
        {
          key: "showrole",
          label: "Action",
          sorter: false,
          _style: "width:1%",
          filter: false
        }
      ],
      items: null
    };
  },
  computed: {
    ...mapState(["roles"])
  },
  async mounted() {
    this.items = await this.getRoles();
  },
  methods: {
    ...mapActions(["getRoles"]),
    getRole(role) {
      this.$router.push({ path: "roles/"+role.id, params: { role: role } });
    }
  },
  components: {
    TheTable
  }
};
</script>

<style>
.cursor {
  cursor: pointer;
}
</style>
